import { takeLatest, call, put } from 'redux-saga/effects'
import * as constants from 'store/constants'
import api from './api'

function* getInvoiceExtract({ payload }) {
  try {
    yield put({ type: constants.INVOICE_EXTRACT_LOADING, payload: true })

    const res = yield call(api.getInvoiceExtract, payload)

    yield put({ type: constants.INVOICE_EXTRACT_DATA, payload: res })
    yield put({ type: constants.INVOICE_EXTRACT_LOADING, payload: false })
  } catch (e) {
    yield put({ type: constants.INVOICE_EXTRACT_ERROR, payload: e.message || e })
    yield put({ type: constants.INVOICE_EXTRACT_LOADING, payload: false })
  }
}

export default function* invoiceExtractSaga() {
  yield takeLatest(constants.GET_INVOICE_EXTRACT, getInvoiceExtract)
}
